define('modules/common/service/CambiaPassword',[], function() {
    var Service = function(
        $http, 
        PATH, 
        Token, 
        Studio,
        uuid4,
        toaster) {

        return function(dati){
           
            var comando = {
                "comando": "modificapasswordstudioonline",
                "uuid": uuid4.generate(),
                "parametri": {
                    "password" : dati.newpassword
                    },
                "precedenti": {"password": dati.oldpassword}
            };

            return Studio.getId().then(function(id){
                return $http({
                    method:'POST',
                    url: 'https://' + PATH.ENTRYPOINT + '/' + id + '/daticliente/modificapassword',
                    headers: {
                       'Authorization': 'TOKEN:' + Token.get()
                    },
                    data:comando
                });
            });
        };
    };

    return [
        "$http", 
        "PATH", 
        "Token", 
        "Studio",
        "uuid4",
        "toaster",
        Service
    ];
});
